<template>
    <DashboardLayout :user="user">
        <div class="border border-gray-300 bg-white rounded-lg shadow-lg max-w-4xl mx-auto pb-10">

            <div class="bg-gray-200 text-lg font-semibold px-6 py-3 rounded-t-lg text-left">
                Dashboard
            </div>

            <!-- Grid Layout for Icons -->
            <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mt-5 px-6 py-4">

                <!-- Bank Accounts -->
                <div @click="navigateTo('/bank-accounts')" class="dashboard-card">
                    <i class="fas fa-university text-4xl text-blue-500"></i>
                    <p>Bank Accounts</p>
                </div>

                <!-- Loans -->
                <div @click="navigateTo('/loans')" class="dashboard-card">
                    <i class="fas fa-money-bill-wave text-4xl text-green-500"></i>
                    <p>Loans</p>
                </div>

                <!-- Term Deposits -->
                <div @click="navigateTo('/term-deposits')" class="dashboard-card">
                    <i class="fas fa-piggy-bank text-4xl text-yellow-500"></i>
                    <p>Deposits</p>
                </div>

                <!-- Account Details -->
                <div @click="navigateTo('/account-details')" class="dashboard-card">
                    <i class="fas fa-user-circle text-4xl text-purple-500"></i>
                    <p>Account Details</p>
                </div>

                <!-- Account Types -->
                <div @click="navigateTo('/beneficiary')" class="dashboard-card">
                    <i class="fas fa-list text-4xl text-teal-500"></i>
                    <p>Beneficiary</p>
                </div>

                <!-- Change Password -->
                <div @click="navigateTo('/update-profile')" class="dashboard-card">
                    <i class="fas fa-key text-4xl text-red-500"></i>
                    <p>Change Password</p>
                </div>


                <!-- <iframe scrolling="no" frameborder="0" allowtransparency="true" :src="user.unid_src"
                    style="width:500px;height:48px;padding:0px 0px 0px 20px;"></iframe> -->


            </div>
        </div>





    </DashboardLayout>

</template>

<script>

import DashboardLayout from "@/components/DashboardLayout.vue";

export default {
    name: 'UserDashboard',
    components: {
        DashboardLayout
    },
    data() {
        return {
            user: {},
        };
    },
    created() {
        const userData = localStorage.getItem('user');
        if (!userData) {
            // alert("Session expired. Please log in again.");
            this.$router.push("/");
            return; // Stop further execution
        }
        this.user = JSON.parse(userData);
    },
    // mounted() {
    //     if (this.user.unid_src) {
    //         const script = document.createElement("script");
    //         script.src = "//auth2.unid.net/js/callback.js";
    //         script.async = true;
    //         document.body.appendChild(script);
    //     }
    // },
    methods: {
        navigateTo(route) {
            this.$router.push(route);
        },
    }
}

</script>
<style scoped>
/* Style for the dashboard cards */
.dashboard-card {
    @apply flex flex-col items-center justify-center bg-white rounded-lg shadow-md p-6 cursor-pointer transition-transform transform hover:scale-105;
}

.dashboard-card p {
    @apply mt-2 text-gray-700 font-semibold;
}
</style>